import {useState} from "react";

enum FILTER_PANEL {
  VACCINE_TYPE = 'vaccineType',
  REGION = 'region'
}
const DEFAULT_SELECTED = ['不限'];

export const useMedicalOrganizationVaccinesFilter = () => {
  const [openPanel, setOpenPanel] = useState<FILTER_PANEL | ''>('');
  const [selectedVaccineTypes, setSelectedVaccineTypes] = useState<string[]>(DEFAULT_SELECTED);
  const [selectedRegions, setSelectedRegions] = useState<string[]>(DEFAULT_SELECTED);

  const isShowVaccineTypeSelect = openPanel === FILTER_PANEL.VACCINE_TYPE;
  const isShowRegionSelect = openPanel === FILTER_PANEL.REGION;

  const toggleVaccineTypePanel = () => {
    setOpenPanel(prev => (prev === FILTER_PANEL.VACCINE_TYPE ? '' : FILTER_PANEL.VACCINE_TYPE));
  };

  const toggleRegionPanel = () => {
    setOpenPanel(prev => (prev === FILTER_PANEL.REGION ? '' : FILTER_PANEL.REGION));
  };

  const closeAllPanels = () => setOpenPanel('');

  const onVaccineTypeSelectionCompleted = closeAllPanels;
  const onRegionSelectionCompleted = closeAllPanels;

  const isOverlayVisible = openPanel !== '';

  return {
    selectedRegions,
    selectedVaccineTypes,
    setSelectedVaccineTypes,
    setSelectedRegions,
    isShowVaccineTypeSelect,
    isShowRegionSelect,
    isOverlayVisible,
    toggleVaccineTypePanel,
    toggleRegionPanel,
    closeAllPanels,
    onVaccineTypeSelectionCompleted,
    onRegionSelectionCompleted,
  };
}
